import { render } from "./SurveyPassings.vue?vue&type=template&id=105dd856&scoped=true"
import script from "./SurveyPassings.vue?vue&type=script&lang=js"
export * from "./SurveyPassings.vue?vue&type=script&lang=js"

import "./SurveyPassings.vue?vue&type=style&index=0&id=105dd856&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105dd856"]])

export default __exports__